var n;!function(n){n.Annuity="annuity",n.ResidualPayment="residualPayment"}(n||(n={}));export{n as CreditType};
//# sourceMappingURL=credit.js.map
